import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import { connect } from "react-redux";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import {
  publishPermutationRequests,
  getPermutationSummary,
} from "../../../../store/transfer/actions";
import { useEffect } from "react";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const PermutationSummaryDialog = (props) => {
  const {
    loading,
    showDialog,
    setShowDialog,
    publishPermutationRequests,
    getPermutationSummary,
    permutationSummary,
    permutationSchedule,
  } = props;

  const { hasPermissions } = useRequiredAuth();

  useEffect(() => {
    if (!!showDialog) getPermutationSummary();
  }, []);

  const [confirmPermutations, setConfirmPermutations] = useState(false);

  return (
    <>
      <Dialog
        onClose={() => {
          setShowDialog(false);
        }}
        fullWidth
        maxWidth="sm"
        open={showDialog}
      >
        <DialogTitle>
          <Typography className="text-center">Permutations summary</Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="rounded border" style={{ overflow: "hidden" }}>
            <table className="table table-striped" style={{ fontSize: "12px" }}>
              <tr>
                <th
                  style={{ width: "50%" }}
                  className="text-right text-primary text-uppercase"
                >
                  Total
                </th>
                <th className=" text-primary text-uppercase">
                  {permutationSummary.total || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-success  text-uppercase">
                  Accepted
                </th>
                <th className="text-success">
                  {permutationSummary.accepted || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-danger  text-uppercase">
                  Rejected
                </th>
                <th className="text-danger">
                  {permutationSummary.rejected || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-secondary  text-uppercase">
                  Pending
                </th>
                <th className="text-secondary">
                  {permutationSummary.pending || 0}
                </th>
              </tr>
            </table>
          </div>
        </DialogContent>
        {hasPermissions(["TRANSFER_PERMUTATION_PERMUTATIONS_PUBLISH"]) && (
          <DialogActions className="d-flex justify-content-center pb-4">
            <Button
              color="success"
              variant="contained"
              onClick={() => setConfirmPermutations(true)}
              type="button"
              disabled={
                loading ||
                !!permutationSummary.published ||
                !permutationSummary.total ||
                !permutationSchedule ||
                !!permutationSummary.pending
              }
              className="mt-n3 px-5"
            >
              <span className="material-icons">publish</span>
              Publish
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {confirmPermutations && (
        <ConfirmationDialog
          confirmationDialog={confirmPermutations}
          message={
            <>
              <span>Are you sure you want to publish?</span>
            </>
          }
          setConfirmationDialog={setConfirmPermutations}
          onYes={() => {
            publishPermutationRequests(() => {
              setConfirmPermutations(false);
              setShowDialog(false);
            });
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  permutationSummary,
  permutationSchedule,
}) => {
  return { loading, permutationSummary, permutationSchedule };
};
export default connect(mapStateToProps, {
  publishPermutationRequests,
  getPermutationSummary,
})(PermutationSummaryDialog);
